import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import {
  CreateDumpFileForSingleDbErrorResponse,
  createDumpFileForSingleDB,
  CreateDumpFileForSingleDbPayload,
  CreateDumpFileForSingleDbSuccessResponse,
} from '../services/CreateDumpFileForSingleDBApi';
import { useNotification } from 'hooks/useNotification';
import ApiClientManager from 'core/apiClient';

export const useCreateDumpFile = () => {
  const token = useSelector(selectAuthToken);
  const { showError } = useNotification();

  const mutation = useMutation<
    AxiosResponse<CreateDumpFileForSingleDbSuccessResponse>,
    AxiosResponse<CreateDumpFileForSingleDbErrorResponse>,
    CreateDumpFileForSingleDbPayload
  >({
    mutationFn: async (params) => {
      if (!token) {
        throw new Error('No auth token available');
      }
      const config =
        params.tenantName || params.realmId
          ? {
              headers: ApiClientManager.buildUrlHeaders({
                tenantName: params.tenantName,
                realmId: params.realmId,
              }),
            }
          : {};
      return createDumpFileForSingleDB({ params, token, config }) as Promise<
        AxiosResponse<CreateDumpFileForSingleDbSuccessResponse>
      >;
    },
    onError: (error) => {
      showError(`Create dump file failed! ${error.data.message}`);
    },
  });
  return {
    createDumpFile: mutation.mutate,
    isCreatingDumpFile: mutation.isPending,
    dumpFile: mutation.data?.data,
  };
};
